import { PeriodTypeOverrides, PeriodTypeOverridesWithInherited } from '@/types/powerMarkets/balancing/PeriodTypeOverrides.ts';

export const INHERITED_PERIOD_TO_USE_INFO = 'Defaulted to the site wide setting.';

export const periodToUseSiteWideOptions: Array<{
    name: string;
    id: PeriodTypeOverrides;
}> = [
    { name: 'Current', id: 'current' },
    { name: 'Trading Window', id: 'trading' },
    { name: 'Latest BM Window', id: 'latest' },
];

export const periodToUsePageOverrideOptions: Array<{
    name: string;
    id: PeriodTypeOverridesWithInherited;
    info?: string;
}> = [
    { name: 'Inherited', id: 'inherited', info: INHERITED_PERIOD_TO_USE_INFO },
    ...periodToUseSiteWideOptions,
];
